var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tabs as MuiTabs, Tab, Box } from "@mui/material";
import "../../css/TabsContainer.css";
import { NavigationBL } from "./NavigationBL";
import { useDrawerContext } from "./NavigationBL";
import AlertDialog from "../AlertBox/AlertBox";
import { useDeviceQueries } from "../../shared/Utilites";
export default function Navigation(props) {
    var _a = NavigationBL(props), handleChange = _a.handleChange, componentIndex = _a.componentIndex, handleChangeTab = _a.handleChangeTab, tabsArray = _a.tabsArray, a11yProps = _a.a11yProps, openAlertBox = _a.openAlertBox, setOpenAlertBox = _a.setOpenAlertBox, redirectTabIndex = _a.redirectTabIndex;
    var setMobileOpen = useDrawerContext().setMobileOpen;
    var isMobile = useDeviceQueries();
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ textAlign: isMobile ? "left" : "left" }, { children: _jsx(MuiTabs, __assign({ className: isMobile ? "ST_navigation_tabs_Mobile" : "navigation-Tabs", orientation: "vertical", variant: "scrollable", value: componentIndex, onChange: handleChange, "aria-label": "Vertical tabs example" }, { children: tabsArray === null || tabsArray === void 0 ? void 0 : tabsArray.map(function (tab, index) {
                        return tab.isActive ? (!isMobile ? (_jsx(Tab, __assign({ onClick: function () {
                                handleChangeTab(index, true);
                                setMobileOpen(false);
                            }, className: "navigation-Tab", icon: tab.icon, iconPosition: "start", label: tab.label }, a11yProps(tab.index)), tab.index)) : (_jsx(Tab, __assign({ onClick: function () {
                                handleChangeTab(index, true);
                                setMobileOpen(false);
                            }, className: "ST_navigation_tab_Mobile", label: tab.label }, a11yProps(tab.index)), tab.index))) : null;
                    }) })) })), _jsx(AlertDialog, { openAlertBox: openAlertBox, setOpenAlertBox: setOpenAlertBox, redirectTabIndex: redirectTabIndex })] }));
}
